import { asyncActionType } from "utils/constants";

export const SET_DEEP_LINK_PATH = "SET_DEEP_LINK_PATH";
export const SET_DEEP_LINK_REDIRECTED = "SET_DEEP_LINK_REDIRECTED";
